<template v-once>
  <img src="@/assets/icons/pulse_media_icon.png" alt="pulse media icon">
</template>

<script>
export default {
  name: "PulseMedia",
};
</script>

<style scoped>
</style>
